var render = function render(){var _vm=this,_c=_vm._self._c;return _c('font-awesome-layers',{staticClass:"result-table",attrs:{"fa-fw":""}},[_c('font-awesome-icon',{class:_vm.variant,attrs:{"icon":"fa-thin fa-circle","size":"2x"}}),_c('font-awesome-icon',{class:_vm.variant,attrs:{"icon":"fa-solid fa-circle","transform":"shrink-4","size":"2x"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }